var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcheology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-27 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m186.714844 0v182h-90v75c0 76.1875-18.007813 152.476562-52.082032 220.621094l-17.1875 34.378906h273.542969l10.476563-20.960938c33.910156-67.816406 52.820312-143.238281 55.03125-219.039062h.21875v-90h-90v-182zm30 30h30v152h-30zm67.917968 447.621094-2.1875 4.378906h-206.570312c31.136719-65.445312 48.507812-137.5625 50.621094-210.011719h29.988281c-1.644531 54.707031-12.296875 108.367188-31.730469 159.699219l28.054688 10.625c20.726562-54.742188 32.03125-111.972656 33.6875-170.324219h29.988281c-1.644531 54.707031-12.296875 108.367188-31.730469 159.699219l28.054688 10.621094c20.726562-54.738282 32.03125-111.96875 33.6875-170.320313h29.988281c-1.644531 54.707031-12.296875 108.367188-31.730469 159.699219l28.054688 10.621094c20.726562-54.738282 32.03125-111.972656 33.6875-170.320313h29.984375c-2.203125 71.167969-20.011719 141.960938-51.847657 205.632813zm52.082032-235.621094h-210v-30h210zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m381.714844 415.78125 21.214844 21.214844-21.214844 21.210937-21.210938-21.210937zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m336.714844 482h30v30h-30zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m426.714844 452h30v30h-30zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.714844 458.214844-21.214844-21.210938 21.214844-21.214844 21.210937 21.214844zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcheology);
export default __webpack_public_path__ + "static/media/archeology.2c322a981504e634e9f24736275c776b.svg";
export { ForwardRef as ReactComponent };